/**
 * OpsPlus Module
 * DevOps monitoring and infrastructure management module
 */

import type { Module } from '../../index';
import { opsPlusRoutes } from './routes/config';

// Export components
export * from './components';

// Export services
export * from './services';

// Export lib
export * from './lib/types';
export * from './lib/store';

// Export pages
export { default as Dashboard } from './pages/Dashboard';
export { default as Projects } from './pages/Projects';
export { default as Alerts } from './pages/Alerts';
export { default as Logs } from './pages/Logs';
export { default as Topology } from './pages/Topology';

/**
 * OpsPlus Module Definition
 */
const opsPlusModule: Module = {
  name: 'opsplus',
  path: '/app/opsplus',
  routes: opsPlusRoutes,
  components: {
    // Export any shared components here
  },
  services: {
    // Export any shared services here
  },
};

export default opsPlusModule;
